export const productSolutionMenu = [
    {
        id: 7,
        text: "Company Products",
        slug: "company-products",
        img: require("../../images/960x0.jpg"),
        banner: require("../../images/banner/banner---san-pham-giai-phap---giai-phap-y-te.jpg"),
    },
    {
        id: 1,
        text: "Healthcare Solutions",
        slug: "healthcare-solutions",
        img: require("../../images/product_solution/banner---home-giai-phap-y-te.png"),
        banner: require("../../images/banner/banner---san-pham-giai-phap---giai-phap-y-te.jpg"),
    },
    {
        id: 2,
        text: "System Integration",
        slug: "systen-intergation",
        img: require("../../images/product_solution/banner---home-tich-hop-he-thong.jpg"),
        banner: require("../../images/banner/banner---san-pham-giai-phap---tich-hop-he-thong.jpg"),
    },
    {
        id: 3,
        text: "IT Services and Infrastructure",
        slug: "it-services-and-infrastructure",
        img: require("../../images/product_solution/banner---home-ha-tang-cntt.jpg"),
        banner: require("../../images/banner/banner---san-pham-giai-phap---dich-vu-va-ha-tang-cntt.jpg"),
    },
    {
        id: 4,
        text: "Enterprise 4.0 Solutions",
        slug: "enterprise-40-solutions",
        img: require("../../images/product_solution/banner---home-giai-phap-doanh-nghiep-4-0.jpg"),
        banner: require("../../images/banner/banner---san-pham-giai-phap---giai-phap-doanh-nghiep-4-0.jpg"),
    },
    {
        id: 5,
        text: "Cloud Services",
        slug: "cloud-services",
        img: require("../../images/product_solution/banner---home-giai-phap-cloud.jpg"),
        banner: require("../../images/banner/banner---san-pham-giai-phap---dich-vu-cloud.jpg"),
    },
    {
        id: 6,
        text: "IoT Solutions",
        slug: "iot-solutions",
        img: require("../../images/product_solution/banner---home-giai-phap-iot.jpg"),
        banner: require("../../images/banner/banner---san-pham-giai-phap---giai-phap-iot.jpg"),
    },
]
